// LocalSend-style friendly placeholder display name (user decision, iW10):
// Adjective + Fruit, e.g. "Cool Mango" — used on every platform when an
// account is created without a chosen name, so skipping the name step never
// yields a blank or a shared static value. Display names are not identifiers
// in Merkury (the UUID is), so collisions are harmless.
//
// SECURITY: drawn from INDEPENDENT CSPRNG randomness — never derive a public
// name from the recovery phrase or identity key (that would leak secret
// material). Keep this module dependency-free: the headless brain imports it
// and must stay WASM-free/browser-free.

const NAME_ADJECTIVES = [
  'Big', 'Cool', 'Swift', 'Brave', 'Calm', 'Bright', 'Lucky', 'Quiet',
  'Sunny', 'Wild', 'Neat', 'Bold', 'Merry', 'Clever', 'Gentle', 'Prime',
] as const;

const NAME_FRUITS = [
  'Blueberry', 'Mango', 'Peach', 'Cherry', 'Plum', 'Apricot', 'Melon',
  'Papaya', 'Kiwi', 'Lemon', 'Fig', 'Olive', 'Grape', 'Banana', 'Coconut',
  'Quince',
] as const;

/** A fresh "Cool Mango"-style name from crypto randomness (≤64 runes always). */
export function friendlyPlaceholderName(): string {
  const b = new Uint8Array(2);
  crypto.getRandomValues(b);
  return `${NAME_ADJECTIVES[b[0]! % NAME_ADJECTIVES.length]!} ${NAME_FRUITS[b[1]! % NAME_FRUITS.length]!}`;
}
